import { render, staticRenderFns } from "./PopupAdd.vue?vue&type=template&id=54021d85&"
import script from "./PopupAdd.vue?vue&type=script&lang=ts&"
export * from "./PopupAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports